module.exports = __webpack_public_path__ + "img/go6.8376dbaf.png";